import { useHoverIntent } from '@hooks/useHoverIntent';
import SvgArrowRight from '@img/icons/arrow-right.svg';
import * as React from 'react';
import S from './NavigationDropdown.styles';
const NavigationDropdown = ({ items, title }) => {
    const { handleMouseEnter, handleMouseLeave } = useHoverIntent();
    if (!items || items.length === 0) {
        return null;
    }
    return (React.createElement(S.Container, { "data-dropdown": true, style: { '--columns': `${items.length > 10 ? 2 : 1}` } },
        title && React.createElement(S.DropdownTitle, null, title),
        React.createElement(S.DropdownList, null, items.map((item) => (React.createElement(S.DropdownItem, { key: item.id, onMouseEnter: (e) => handleMouseEnter(e, item.id, 'dropdown'), onMouseLeave: (e) => handleMouseLeave(e, item.id, 'dropdown') },
            React.createElement(S.DropdownLink, { href: item.url, target: item.target ?? '_self' },
                item.text,
                !!item.children?.length && React.createElement(SvgArrowRight, null)),
            !!item.children?.length && (React.createElement(NavigationDropdown, { items: item.children, title: item.text }))))))));
};
export default NavigationDropdown;
